// Verificar que el script se está cargando
console.log('📦 functions.js cargado');

function getPostAddCartModalConfig() {
  return window.postAddCartModalConfig || null;
}

function shouldShowPostAddCartModal(productId) {
  const cfg = getPostAddCartModalConfig();
  if (!cfg || !cfg.enabled || productId == null) return false;
  const rawIds = cfg.productIds;
  if (!Array.isArray(rawIds) || rawIds.length === 0) return false;
  const pid = Number(productId);
  if (Number.isNaN(pid)) return false;
  return rawIds.some((id) => Number(id) === pid);
}

function closePostAddCartModal() {
  const root = document.getElementById('post-add-cart-modal');
  if (!root) return;
  root.hidden = true;
  root.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('post-add-cart-modal-open');
}

function openPostAddCartModal() {
  const root = document.getElementById('post-add-cart-modal');
  if (!root) return;
  root.hidden = false;
  root.setAttribute('aria-hidden', 'false');
  document.body.classList.add('post-add-cart-modal-open');
}

function initPostAddCartModal() {
  const cfg = getPostAddCartModalConfig();
  if (!cfg || !cfg.enabled) return;
  const root = document.getElementById('post-add-cart-modal');
  if (!root || root.dataset.modalInit === 'true') return;
  root.dataset.modalInit = 'true';

  root.querySelectorAll('[data-post-add-cart-close]').forEach((el) => {
    el.addEventListener('click', () => closePostAddCartModal());
  });

  const btnContinue = root.querySelector('[data-post-add-cart-continue]');
  if (btnContinue) {
    btnContinue.addEventListener('click', () => {
      const url = (cfg.continueUrl || '').trim();
      closePostAddCartModal();
      if (url) window.location.href = url;
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (root.hidden) return;
    closePostAddCartModal();
  });
}

function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".v2-cart-counter").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=mini-cart");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
}

function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem =
          button.closest("[data-line-item-key]") ||
          button.parentElement.parentElement.parentElement.parentElement
            .parentElement;
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        if (isUp && rootItem.getAttribute("data-qty-locked") === "true") {
          return;
        }
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });

  // Eliminar sin salir de la página (AJAX)
  document.querySelectorAll("[data-lop-cart-remove], .deleteButton").forEach((button) => {
    button.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const rootItem = button.closest("[data-line-item-key]");
      const key = rootItem && rootItem.getAttribute("data-line-item-key");
      if (!key) return;

      button.setAttribute("disabled", "disabled");
      button.style.pointerEvents = "none";

      try {
        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: 0 } }),
        });
        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
        await updateCartDrawer();
      } catch (err) {
        button.removeAttribute("disabled");
        button.style.pointerEvents = "";
      }
    });
  });

  const cartDrawerBox = document.querySelector(".cart-drawer-box");
  if (cartDrawerBox) {
    cartDrawerBox.addEventListener("click", (e) => {
      e.stopPropagation();
    });
  }

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        console.log("closing drawer");
        closeCartDrawer();
      });
    });

  if (typeof addUpsellListeners === "function") {
    addUpsellListeners();
  }
}

addCartDrawerListeners();

document.querySelector(".cart-drawer-header-right-close").addEventListener("click", () => {
  closeCartDrawer();
});

// Función para inicializar los listeners de formularios
function initializeCartForms() {
  const forms = document.querySelectorAll('form[action="/cart/add"]');
  console.log('🔵 Inicializando formularios de carrito:', forms.length);
  
  forms.forEach((form) => {
    
    // Skip forms that have their own handler (like CO2 product form)
    if (form.getAttribute('data-co2-form') === 'true') {
      console.log('⏭️ Saltando formulario CO2');
      return;
    }
    
    // Evitar agregar múltiples listeners
    if (form.hasAttribute('data-cart-listener-added')) {
      console.log('⏭️ Listener ya agregado a este formulario');
      return;
    }
    form.setAttribute('data-cart-listener-added', 'true');
    
    // Interceptar el click del botón en lugar del submit del formulario
    const submitButton = form.querySelector('button[type="submit"]');
    if (!submitButton) {
      console.log('⚠️ No se encontró botón submit en el formulario');
      return;
    }
    
    console.log('✅ Agregando listener al botón:', submitButton);
    
    submitButton.addEventListener("click", async (e) => {
    console.log('🟢 Click en botón interceptado');
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (form.hasAttribute("data-qty-locked") || form.classList.contains("qty-locked-gift")) {
      return;
    }

    // Verificar que el botón no esté deshabilitado
    if (submitButton.hasAttribute('disabled') || submitButton.classList.contains('disabled')) {
      console.log('⚠️ Botón deshabilitado, cancelando');
      return;
    }

    // Deshabilitar botón antes del fetch
    submitButton.setAttribute("disabled", "disabled");
    const originalText = submitButton.textContent || submitButton.innerHTML;

    try {
      // Obtener variant ID del formulario
      const variantInput = form.querySelector('input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');
      
      let variantId = null;
      let quantity = 1;
      
      // Obtener variant ID
      if (variantInput) {
        variantId = variantInput.value;
      } else {
        // Intentar obtener del select si existe
        const variantSelect = form.querySelector('select[name="id"]');
        if (variantSelect) {
          variantId = variantSelect.value;
        }
      }
      
      // Obtener cantidad
      if (quantityInput) {
        quantity = parseInt(quantityInput.value) || 1;
      }
      
      // Debug: verificar datos antes de enviar
      console.log('Datos del formulario:', {
        variantId: variantId,
        quantity: quantity,
        variantInput: variantInput ? variantInput.value : 'no encontrado',
        quantityInput: quantityInput ? quantityInput.value : 'no encontrado'
      });
      
      if (!variantId || variantId === '' || variantId === 'undefined' || variantId === null) {
        console.error('Error: No se encontró un variant ID válido');
        throw new Error('No se ha seleccionado una variante del producto. Por favor, recarga la página e intenta nuevamente.');
      }
      
      // Convertir variant ID a número si es necesario
      variantId = parseInt(variantId);
      if (isNaN(variantId)) {
        throw new Error('El ID de la variante no es válido');
      }

      // Preparar propiedades del formulario si existen
      const properties = {};
      const propertyInputs = form.querySelectorAll('input[name^="properties["]');
      propertyInputs.forEach(input => {
        const name = input.name.match(/properties\[(.*?)\]/)?.[1];
        if (name && input.value) {
          properties[name] = input.value;
        }
      });

      // Preparar datos para enviar
      const cartData = {
        id: variantId,
        quantity: quantity
      };
      
      if (Object.keys(properties).length > 0) {
        cartData.properties = properties;
      }

      const cartBeforeRes = await fetch("/cart.js", {
        credentials: "same-origin",
      });
      if (!cartBeforeRes.ok) {
        throw new Error("Error al obtener el carrito");
      }
      const cartBefore = await cartBeforeRes.json();
      const variantAlreadyInCart = (cartBefore.items || []).some(
        (item) => Number(item.variant_id) === variantId
      );

      if (form.hasAttribute("data-qty-locked") || form.classList.contains("qty-locked-gift")) {
        quantity = 1;
        cartData.quantity = 1;
        const existingQty = (cartBefore.items || [])
          .filter((item) => Number(item.variant_id) === variantId)
          .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
        if (existingQty >= 1) {
          await updateCartDrawer();
          openCartDrawer();
          return;
        }
      }

      // Submit form with ajax usando /cart/add.js (formato JSON)
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify(cartData)
      });

      // Verificar si la respuesta fue exitosa
      if (!addResponse.ok) {
        let errorMessage = 'Error al agregar al carrito';
        try {
          const errorText = await addResponse.text();
          console.error('Error del servidor:', errorText);
          // Intentar parsear como JSON si es posible
          try {
            const errorJson = JSON.parse(errorText);
            if (errorJson.description) {
              errorMessage = errorJson.description;
            } else if (errorJson.message) {
              errorMessage = errorJson.message;
            }
          } catch {
            // Si no es JSON, usar el texto completo si es corto
            if (errorText.length < 200) {
              errorMessage = errorText;
            }
          }
        } catch (e) {
          console.error('Error al leer respuesta:', e);
        }
        throw new Error(errorMessage);
      }

      // Parsear respuesta JSON
      const addResult = await addResponse.json();
      console.log('Producto agregado:', addResult);
      
      // Verificar si hay errores en la respuesta
      if (addResult && addResult.description) {
        throw new Error(addResult.description);
      }
      
      // Verificar si el producto se agregó correctamente
      if (!addResult || (addResult.status && addResult.status !== 200)) {
        throw new Error('No se pudo agregar el producto al carrito');
      }

      // Get cart count
      const res = await fetch("/cart.js");
      if (!res.ok) {
        throw new Error('Error al obtener el carrito');
      }
      
      const cart = await res.json();
      updateCartItemCounts(cart.item_count);

      // Update cart
      await updateCartDrawer();

      const lineProductId =
        addResult.product_id != null
          ? addResult.product_id
          : addResult.items &&
            addResult.items[0] &&
            addResult.items[0].product_id;

      if (
        shouldShowPostAddCartModal(lineProductId) &&
        !variantAlreadyInCart
      ) {
        initPostAddCartModal();
        openPostAddCartModal();
      } else {
        // Open cart drawer solo si todo fue exitoso
        openCartDrawer();
      }

    } catch (error) {
      console.error('Error al agregar producto al carrito:', error);
      alert(error.message || 'Error al agregar el producto al carrito. Por favor, intenta nuevamente.');
    } finally {
      // Rehabilitar botón
      submitButton.removeAttribute("disabled");
      if (submitButton.textContent !== originalText) {
        submitButton.textContent = originalText;
        submitButton.innerHTML = originalText;
      }
    }
  });
  });
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initPostAddCartModal();
    initializeCartForms();
  });
} else {
  initPostAddCartModal();
  initializeCartForms();
}

// También inicializar después de un pequeño delay para asegurar que todos los formularios estén renderizados
setTimeout(() => {
  console.log('🔄 Re-inicializando formularios después de delay');
  initPostAddCartModal();
  initializeCartForms();
}, 100);

// Inicializar también cuando la página esté completamente cargada
window.addEventListener('load', () => {
  console.log('🔄 Re-inicializando formularios después de load');
  initPostAddCartModal();
  initializeCartForms();
});

document.querySelectorAll('.header-cart').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});


